// eslint-disable-next-line func-names

function $(selector, context) {
  // eslint-disable-next-line no-param-reassign
  context = context || document;
  return context.querySelectorAll(selector);
}

function forEach(collection, iterator) {
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in Object.keys(collection)) {
    iterator(collection[key]);
  }
}

function showMenu(menu) {
  // eslint-disable-next-line no-var,no-redeclare
  var menu = this;
  const ul = $('ul', menu)[0];

  if (!ul || ul.classList.contains('-visible')) return;

  menu.classList.add('-active');
  ul.classList.add('-animating');
  ul.classList.add('-visible');
  setTimeout(() => {
    ul.classList.remove('-animating');
  }, 25);

  const parentMenu = menu.closest(
    '.c-megamenu__dropdown:not(.c-megamenu__dropdown--sub)',
  );
  const dropdown = menu.querySelector('.c-megamenu__dropdown--sub');
  if (parentMenu && dropdown) {
    parentMenu.classList.add('c-megamenu__dropdown--opened');
    parentMenu.style.minHeight = `calc(${dropdown.offsetHeight}px + 3rem)`;
  }
}

function hideMenu(menu) {
  // eslint-disable-next-line no-var,no-redeclare
  var menu = this;
  const ul = $('ul', menu)[0];

  if (!ul || !ul.classList.contains('-visible')) return;

  menu.classList.remove('-active');
  ul.classList.add('-animating');
  setTimeout(() => {
    ul.classList.remove('-visible');
    ul.classList.remove('-animating');
  }, 300);

  const parentMenu = menu.closest(
    '.c-megamenu__dropdown:not(.c-megamenu__dropdown--sub)',
  );
  const dropdown = menu.querySelector('.c-megamenu__dropdown--sub');
  if (parentMenu && dropdown) {
    parentMenu.classList.remove('c-megamenu__dropdown--opened');
    parentMenu.style.minHeight = '';
  }
}

function hideAllInactiveMenus(menu) {
  // eslint-disable-next-line no-var,no-redeclare
  var menu = this;
  forEach($('li.-hasSubmenu.-active:not(:hover)', menu.parent), e => {
    // eslint-disable-next-line no-unused-expressions
    e.hideMenu && e.hideMenu();
  });
}

window.addEventListener('load', () => {
  forEach($('.c-megamenu li.-hasSubmenu'), e => {
    e.showMenu = showMenu;
    e.hideMenu = hideMenu;
  });

  forEach($('.c-megamenu > li.-hasSubmenu'), e => {
    e.addEventListener('mouseenter', showMenu);
  });

  forEach($('.c-megamenu > li.-hasSubmenu li'), e => {
    e.addEventListener('mouseenter', hideAllInactiveMenus);
  });

  forEach($('.c-megamenu > li.-hasSubmenu li.-hasSubmenu'), e => {
    e.addEventListener('mouseenter', showMenu);
  });

  forEach($('.c-megamenu > li.-hasSubmenu'), e => {
    e.addEventListener('mouseleave', hideAllInactiveMenus);
  });

  document.addEventListener('click', hideAllInactiveMenus);
});
